// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"imagePlaceholder_wrapper__jFOnd"};